export const BASE_URL = "https://api.staysecured.online/v1/"
export const Response_Code = {
  success: 200
}